import type { BaseTableRowElement } from 'cadenza/base-table/base-table-types';

export const AFTER_TABLE_CONFIGURATION = 'after-table-configuration';
export const ROW_NUMBER_COLUMN_VISIBILITY_CHANGED = 'rowNumberColumnVisibilityChanged';
export const DATATABLE_INITIALIZED = 'datatable:initialized';
export const DATATABLE_DESTROYED = 'datatable:destroyed' as const;
export const DATATABLE_ROW_RENDERED = 'datatable:row:rendered' as const;
export const DATATABLE_CELL_RENDERED = 'datatable:cell:rendered' as const;
export const DATATABLE_THEAD_RENDERED = 'datatable:thead:rendered' as const;

export interface DataTableRowRenderedEventDetail {
  row: BaseTableRowElement;
}

export interface DataTableTheadRenderedEventDetail {
  thead: HTMLTableSectionElement;
}
